import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-mark-as-completecommon-dialog',
  templateUrl: './mark-as-completecommon-dialog.component.html',
  styleUrls: ['./mark-as-completecommon-dialog.component.css']
})
export class MarkAsCompletecommonDialogComponent implements OnInit {

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }
  close() {
    this.dialog.closeAll();
  }
}
